import { MouseEvent, useState } from 'react';
import { Button, ModalPopup } from 'components';
import clsx from 'clsx';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { useAiScribeContext } from '../context/useAiScribe';
import style from './recordingActions.module.scss';

const RecordingActions = () => {
  const { enableMpiUpdate } = useFlags();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [modalContainer, setModalContainer] = useState<HTMLElement>();
  const [isDeleting, setIsDeleting] = useState(false);
  const { isPaused, isSubmitting, stopRecording, deleteRecording } = useAiScribeContext();

  if (!isPaused) return null;

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      const wasDeleted = await deleteRecording();
      if (wasDeleted) {
        setShowDeleteConfirmation(false);
      }
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <div className={clsx(style.actions, !enableMpiUpdate && style.submitOnlyActions)}>
        {enableMpiUpdate && (
          <Button
            text="Delete"
            type="button"
            theme="borderless"
            size="small"
            customStyleClass={style.deleteButton}
            handleOnClick={(event: MouseEvent<HTMLButtonElement>) => {
              setModalContainer(
                event.currentTarget.closest<HTMLElement>('[data-vaul-drawer]') ?? undefined
              );
              setShowDeleteConfirmation(true);
            }}
          />
        )}
        <Button
          text="Submit"
          type="button"
          theme="borderless"
          disabled={isSubmitting}
          customStyleClass={style.submitButton}
          handleOnClick={() => stopRecording()}
        />
      </div>

      {enableMpiUpdate && (
        <ModalPopup
          open={showDeleteConfirmation}
          container={modalContainer}
          customClassInsideContainer={style.modal}
          customClassModalContentContainer={style.modalContent}
        >
          <div className={style.confirmation}>
            <h3 id="parent-modal">Are you sure you want to delete this recording?</h3>
            <div className={style.confirmationActions}>
              <Button
                text="Cancel"
                type="button"
                theme="transparent"
                customStyleClass={style.cancelButton}
                handleOnClick={() => setShowDeleteConfirmation(false)}
              />
              <Button
                text="Yes, Delete"
                type="button"
                theme="primary"
                disabled={isDeleting}
                customStyleClass={style.confirmButton}
                handleOnClick={handleDelete}
              />
            </div>
          </div>
        </ModalPopup>
      )}
    </>
  );
};

export default RecordingActions;
